<div class="component-container">
  <mat-icon
    (click)="currentPage === 1 ? '' : prevPage()"
    [svgIcon]="currentPage === 1 ? 'chevron-right-disabled' : 'chevron-right'"
    class="icon left"
  ></mat-icon>

  @for (page of pages; track page) {
    <div
      (click)="goToPage(page)"
      [class.active]="page === currentPage"
      class="element text-type-6"
      >
      {{ page }}
    </div>
  }

  <mat-icon
    (click)="currentPage === totalPages ? '' : nextPage()"
    [svgIcon]="currentPage === totalPages ? 'chevron-right-disabled' : 'chevron-right'"
    class="icon right"
  ></mat-icon>

  <span class="summary">Showing {{ currentEndIndex || 0 }}/{{ totalItems || 0 }}</span>
</div>
